import _ from 'underscore'
import {CustomFieldsPrefix} from './constants'

export function collectCustomFieldValues(target) {
    return _.pick(target, (value, key) => key.includes(CustomFieldsPrefix))
}


// WEBPACK FOOTER //
// ./web/js/customFields/utils.js